/**
 * Address abbreviations for rows that cannot afford the whole string.
 *
 * A whole address is "street, city, state zip, country". Its tail is
 * boilerplate at row width — reps tell candidates apart by street and city —
 * and every abbreviated form leaves the whole address one hover away (a
 * tooltip) or one keystroke away (the search keywords still hold it).
 */

/** Street + city: the picker-row form. */
export function shortAddress(whole: string): string {
  const parts = addressParts(whole);
  return parts.slice(0, 2).join(", ") || whole;
}

/** Street only: the sidebar-row form, where even the city is over budget. */
export function streetLine(whole: string): string {
  return addressParts(whole)[0] ?? whole;
}

/**
 * Whether free text reads as a whole address — a project named by the place
 * it is at ("4869 W Malad St, Boise, ID 83705, USA"). A house number leads and
 * at least two commas follow; a name with one comma ("Smith, John") or none
 * is a name. The project's own address field is no help here: a project
 * titled by its address often has none recorded.
 */
export function isAddressLike(text: string): boolean {
  const parts = addressParts(text);
  return parts.length >= 3 && /^\d+[A-Za-z]?\s+\S/.test(parts[0] ?? "");
}

function addressParts(whole: string): string[] {
  return whole
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}
